import { render, staticRenderFns } from "./image-viewer.vue?vue&type=template&id=c5e43660"
import script from "./image-viewer.vue?vue&type=script&lang=js"
export * from "./image-viewer.vue?vue&type=script&lang=js"
import style0 from "./image-viewer.vue?vue&type=style&index=0&id=c5e43660&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5e43660')) {
      api.createRecord('c5e43660', component.options)
    } else {
      api.reload('c5e43660', component.options)
    }
    module.hot.accept("./image-viewer.vue?vue&type=template&id=c5e43660", function () {
      api.rerender('c5e43660', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/components/basic/image/src/image-viewer.vue"
export default component.exports